import React from 'react';
import withRouter from '../../Components/Common/withRouter';
import { layoutModeTypes } from "../../Components/constants/layout";
import logo2dark from '../../assets/images/logo2-dark.png';
import logo2light from '../../assets/images/logo2-light.png';
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';

const ParticlesAuth = ({ children }) => {
    // Get the current layout mode from Redux store
    const selectLayoutState = (state) => state.Layout;
    const layoutData = createSelector(
        selectLayoutState,
        (layout) => ({
            layoutModeType: layout.layoutModeType,
        })
    );
    const { layoutModeType } = useSelector(layoutData);
    
    // Use the actual layout mode from Redux instead of hardcoded logic
    const mode = layoutModeType || layoutModeTypes.LIGHTMODE;
    
    return (
        <React.Fragment>
            <div className="auth-page-wrapper pt-5">
                <div   id="auth-particles">
                   
                    {/* <div className="bg-overlay"></div>

                    <div className="shape">
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
                            <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
                        </svg>
                    </div> */}
                </div>

                {/* pass the children */}
                {children}

                <footer className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <div className="text-center">
                                    <p className="mb-0 text-muted">&copy; {new Date().getFullYear()} SeedNations. Crafted with <i className="mdi mdi-heart text-danger"></i> by DATAPROX</p>
                                </div> */}
                                <div className="text-sm-center d-none d-sm-block">
                                    <span className='mr-5'>Powered by  </span> 
                                {/* Logo logic: Light mode shows light logo, Dark mode shows dark logo */}
                                <div style={{fontSize:'16px',fontWeight:'700'}}><img height="15" className='ml-5' src={mode === layoutModeTypes.LIGHTMODE ? logo2light : logo2dark}></img>  Seed  Nations</div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </React.Fragment>
    );
};

export default withRouter(ParticlesAuth);